import { ChevronRightIcon, Text } from '@cdl/heartbeat-react';
import { InfoModal } from './InfoModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const UnsavedChangesModal = ({ isOpen, onClose, onConfirm }: Props) => {
  return (
    <InfoModal
      isOpen={isOpen}
      title={'⚠️ Unsaved changes detected'}
      onClose={onClose}
      closeButtonLabel='Go back'
      onConfirm={onConfirm}
      confirmButtonLabel='Continue to next ECG'
      confirmButtonRightIcon={<ChevronRightIcon />}
      withDashedBorder
    >
      <Text>
        You have unsaved changes. Please ensure this is intentional before
        moving on to the next ECG.
      </Text>
    </InfoModal>
  );
};
